import { render, staticRenderFns } from "./vehicle-details.vue?vue&type=template&id=a4e1a4b8&"
import script from "./vehicle-details.vue?vue&type=script&lang=js&"
export * from "./vehicle-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports